export default __webpack_public_path__ + "static/media/c2_fg2_corda de scarborough.2854e25e.png";